module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Waiting-25c40a9b7a7bca4749b4402aff77734d.svg";